module.exports = __webpack_public_path__ + "img/VEHICLE.2cca322e.svg";